module.exports = __webpack_public_path__ + "media/tom.572ed39d.wav";